module.exports = __webpack_public_path__ + "static/material-card-outlined-463fafd13698be861ab1f711a55029bf.png";